import React, { useState, useRef, useEffect } from "react";
import "./EditTaskGroup.scss";
import "../../../../components/ModalContent/ModalComponents.scss";
import { normalizeColor } from "../../../../utils/colors";
import ColorPicker from "../../../../components/ColorPicker/ColorPicker";

function EditTaskGroup({
  taskGroupData,
  updateTaskGroup,
  cancelEditTaskGroup,
}) {
  const [name, setName] = useState(taskGroupData?.name || "");
  const [selectedColor, setSelectedColor] = useState(
    normalizeColor(taskGroupData?.color),
  );
  const [showNameError, setShowNameError] = useState(false);

  // Update state when taskGroupData changes
  useEffect(() => {
    if (taskGroupData) {
      setName(taskGroupData.name || "");
      setSelectedColor(normalizeColor(taskGroupData.color));
    }
  }, [taskGroupData]);

  const handleUpdateTaskGroup = () => {
    if (name.trim()) {
      const colorHex = normalizeColor(selectedColor);
      updateTaskGroup(taskGroupData._id, name.trim(), colorHex);
      setShowNameError(false);
    } else {
      setShowNameError(true);
    }
  };

  // Set focus on input field when modal opens
  const inputRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
        inputRef.current.select(); // Select all text for easy editing
      }
    }, 100); // 100ms delay to ensure DOM is ready
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="edit-task-group-content">
      <div className="modal-title">
        <div>Edit Section</div>
      </div>
      <div className="modal-form">
        <div className="modal-form-title">Name</div>
        <input
          ref={inputRef}
          type="text"
          className="modal-text-input"
          placeholder="Section Name"
          value={name}
          onChange={(e) => {
            setName(e.target.value);
            if (showNameError && e.target.value.trim()) {
              setShowNameError(false);
            }
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleUpdateTaskGroup();
            }
          }}
        />
        {showNameError && (
          <div className="modal-helper-text">Please enter a group name</div>
        )}

        <div className="modal-form-title">Color</div>
        <div className="color-picker-wrapper">
          <ColorPicker
            selectedColor={selectedColor}
            onColorSelect={setSelectedColor}
          />
        </div>
        <div className="modal-form-buttons">
          <button
            className="modal-button cancel"
            onClick={() => {
              cancelEditTaskGroup();
            }}
          >
            Cancel
          </button>
          <button className="modal-button save" onClick={handleUpdateTaskGroup}>
            Update
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditTaskGroup;
